import { metricsStore, TypeBoundAxiosInstance } from '@m43/core';
import { ClientSerializableTracingData, TracingResource } from '@mark43/cad-api';
import { PromiseBuffer } from '../common/promises/promise-buffer';

export function setupMetricsStore(apiClient: TypeBoundAxiosInstance) {
    const promiseBuffer = new PromiseBuffer<ClientSerializableTracingData>({
        delay: 30_000,
        callback(inputs) {
            return apiClient.request<TracingResource.RecordWebsocketMessageReceived>({
                method: 'POST',
                url: 'tracing/',
                data: {
                    clientSerializableTracingDatas: inputs,
                },
            });
        },
    });
    promiseBuffer.start();
    metricsStore.onTraceAvailable((trace) => {
        promiseBuffer.enqueue(trace);
    });
}
